"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const snyk_config_1 = require("snyk-config");
exports.config = (0, snyk_config_1.loadConfig)(__dirname + '../..');
//# sourceMappingURL=config.js.map